import TopicCopy from './TopicCopy';

export default TopicCopy;
